import { usePromoActions } from './usePromoActions';
import { usePromoExpandedState, usePromoState } from './usePromoState';

export const usePromoReducer = () => ({
  ...usePromoActions(),
  isShowing: usePromoState(),
  isExpanded: usePromoExpandedState(),
});
